module.exports = __webpack_public_path__ + "img/clear.b9f80a0b.svg";